<template>
  <v-row class="px-3">
    <template v-if="application.identityCardList.length">
      <v-col cols="12" class="pt-3 px-0 border-top">
        <div class="accent--text font-weight-bold">Документ удостоверяющий личность</div>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 border-top"
        v-for="(item, i) in application.identityCardList"
        :key="i"
      >
        <v-col cols="12" class="pt-3 px-0">
          <div class="accent--text font-weight-bold">Гражданство</div>
          <div class="accent--text">{{item.citizenship.name}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Тип документа</div>
          <div class="accent--text">{{item.identityCardDocType.name}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Серия</div>
          <div class="accent--text">{{item.series}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Номер</div>
          <div class="accent--text">{{item.number}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Дата выдачи</div>
          <div class="accent--text">{{item.issueDate}}</div>
        </v-col>
      </v-col>
    </template>

    <template v-if="application.educationList.length">
      <v-col cols="12" class="pt-3 px-0 border-top">
        <div class="accent--text font-weight-bold">Документ об образовании</div>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 border-top"
        v-for="(item, i) in application.educationList"
        :key="i + 50"
      >
        <v-col cols="12" class="pt-3 px-0">
          <div class="accent--text font-weight-bold">Тип документа</div>
          <div class="accent--text">{{item.educationDocType.name}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Серия</div>
          <div class="accent--text">{{item.series}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Номер</div>
          <div class="accent--text">{{item.number}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Дата выдачи</div>
          <div class="accent--text">{{item.issueDate}}</div>
        </v-col>
      </v-col>
    </template>

    <template v-if="application.trainingCertificateList.length">
      <v-col cols="12" class="pt-3 px-0 border-top">
        <div class="accent--text font-weight-bold">Справка об обучении</div>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 border-top"
        v-for="(item, i) in application.trainingCertificateList"
        :key="i + 100"
      >
        <v-col cols="12" class="pt-3 px-0">
          <div class="accent--text font-weight-bold">Образовательная организация</div>
          <div class="accent--text">{{ item.organizationName }}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Серия</div>
          <div class="accent--text">{{item.series}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Номер</div>
          <div class="accent--text">{{item.number}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Дата выдачи</div>
          <div class="accent--text">{{item.issueDate}}</div>
        </v-col>
      </v-col>
    </template>

    <template v-if="application.medicalCertificateList.length">
      <v-col cols="12" class="pt-3 px-0 border-top">
        <div class="accent--text font-weight-bold">Медицинская справка</div>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 border-top"
        v-for="(item, i) in application.medicalCertificateList"
        :key="i + 150"
      >
        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Серия</div>
          <div class="accent--text">{{item.series}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Номер</div>
          <div class="accent--text">{{item.number}}</div>
        </v-col>
      </v-col>
    </template>

    <template v-if="application.militaryList.length">
      <v-col cols="12" class="pt-3 px-0 border-top">
        <div class="accent--text font-weight-bold">Документ о воинской обязанности</div>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 border-top"
        v-for="(item, i) in application.militaryList"
        :key="i + 200"
      >
        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Серия</div>
          <div class="accent--text">{{item.series}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Номер</div>
          <div class="accent--text">{{item.number}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Дата выдачи</div>
          <div class="accent--text">{{item.issueDate}}</div>
        </v-col>
      </v-col>
    </template>

    <template v-if="application.achievementList.length">
      <v-col cols="12" class="pt-3 px-0 border-top">
        <div class="accent--text font-weight-bold">Достижения</div>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 border-top"
        v-for="(item, i) in application.achievementList"
        :key="i + 250"
      >
        <v-col cols="12" class="pt-3 px-0">
          <div class="accent--text font-weight-bold">Наименование достижения</div>
          <div class="accent--text">{{item.name}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Серия</div>
          <div class="accent--text">{{item.series}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Номер</div>
          <div class="accent--text">{{item.number}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Дата выдачи</div>
          <div class="accent--text">{{item.issueDate}}</div>
        </v-col>

        <v-col cols="12" class="pt-0 px-0">
          <div class="accent--text font-weight-bold">Кем выдано</div>
          <div class="accent--text">{{item.issueBy}}</div>
        </v-col>
      </v-col>
    </template>
  </v-row>
</template>

<script>

import {Application} from "@/models";

export default {
  name: "Documents",

  props: {
    application: Application
  },
}
</script>

<style scoped>
.card {
  border-radius: 20px !important;
}

.card-title {
  word-break: normal !important;
}

.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
